const timeSince = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  const timeDiff = today.getTime() - date.getTime();
  const minutesDiff = Math.round(timeDiff / (1000 * 60));

  if (minutesDiff < 60 * 24) {
    return new Date(date).toLocaleTimeString('default', { hour: '2-digit', minute: '2-digit' })
  } else if (minutesDiff < 60 * 24 * 30) {
    const daysDiff = Math.floor(minutesDiff / (60 * 24));
    return `${daysDiff} day${daysDiff > 1 ? 's' : ''} ago`;
  } else if (minutesDiff < 60 * 24 * 365) {
    const monthsDiff = Math.floor(minutesDiff / (60 * 24 * 30));
    return `${monthsDiff} month${monthsDiff > 1 ? 's' : ''} ago`;
  } else {
    const yearsDiff = Math.floor(minutesDiff / (60 * 24 * 365));
    return `${yearsDiff} year${yearsDiff > 1 ? 's' : ''} ago`;
  }
}

// Maps a raw backend Inbox row into the shape ReDoMenuCard expects.
export const mapInboxToCard = (inbox) => ({
  ...inbox,
  id: inbox.id,
  user: { photo: inbox.recipientPhotoURL },
  headline: inbox.recipientDisplayName,
  subHeadline: timeSince(inbox.updatedAt),
  subtitle: inbox.lastMessage,
  unread: inbox.unreadMessageCount,
})
